module.exports = __webpack_public_path__ + "static/media/error-bg.80f80f50.jpg";